import {
    useEffect,
    type FC
} from "react";
import type ICardDescriptionProps from "./type";
import {
    CARD_DESCRIPTION_SKELETON_WIDTH,
    CARD_DESCRIPTION_VARIANT
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    CardPartContentProps
} from "../../type";
import {
    getCardChildrenText,
    getCardHiddenProps
} from "../../util";
import {
    getCardColors
} from "../../stylesheet";
import {
    withCardContext
} from "../../context";
import Skeleton from "../../../skeleton";
import Text from "../../../text";

const CardDescriptionContent: FC<CardPartContentProps<ICardDescriptionProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        registerPart,
        isLoading
    } = context;

    const currentColors = getCardColors({
        isDisabled: context.isDisabled,
        colors
    });

    const text = getCardChildrenText(children);

    const hiddenProps = getCardHiddenProps({
        isPressable: context.isPressable,
        text
    });

    useEffect(() => {
        if(isLoading) {
            return;
        }

        return registerPart("description", text);
    }, [
        registerPart,
        isLoading,
        text
    ]);

    if(isLoading) {
        return <Skeleton
            width={CARD_DESCRIPTION_SKELETON_WIDTH}
            typography={CARD_DESCRIPTION_VARIANT}
            customTheme={customTheme}
            variant="text"
        />;
    }

    return <Text
        {...hiddenProps}
        {...props}
        customColor={currentColors.descriptionColor}
        variant={CARD_DESCRIPTION_VARIANT}
        id={context.descriptionID}
        customTheme={customTheme}
    >
        {children}
    </Text>;
};
export default withCardContext("description", CardDescriptionContent);
